import type { MapSearchOption } from '$mapapp/MapApp/SlideIn/SearchRoutingHistory/MapSearch/MapSearch.Model'

const SEARCH_HISTORY_STORAGE_KEY = 'mineralminds.mapSearch.history'

export function loadSearchHistoryFromSession(): MapSearchOption[] {
	if (typeof window === 'undefined') return []
	try {
		const raw = window.sessionStorage.getItem(SEARCH_HISTORY_STORAGE_KEY)
		return raw ? (JSON.parse(raw) as MapSearchOption[]) : []
	} catch {
		return []
	}
}

export function saveSearchHistoryToSession(history: MapSearchOption[]) {
	if (typeof window === 'undefined') return
	try {
		window.sessionStorage.setItem(SEARCH_HISTORY_STORAGE_KEY, JSON.stringify(history))
	} catch {
		// quota exceeded, or storage disabled — ignore, history just won't persist
	}
}